import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Anchor } from '../common/helper'

import { change_password, logout } from './login-actions'
import config from '../main/config'

import { Row, Grid } from '../common/layout'

class LockPage extends Component{

    componentDidMount() {
        document.body.classList.remove( config().THEME_NAME )
        document.body.classList.remove('sidebar-mini')
        document.body.classList.add('login-page')
    }

    componentWillUnmount() {
        document.body.classList.remove('login-page')
        document.body.classList.add( config().THEME_NAME )
        document.body.classList.add('sidebar-mini')
    }

    onSubmit(values) {
        const { change_password } = this.props
        change_password(values)
    }

    render() {

        return (
        <div className="login-box">
            <div className="login-logo">
                <Anchor href="/">{config().NOME_SISTEMA || 'Nome Sistema'}</Anchor>
            </div>
            <div className="login-box-body">

                <h3 className="login-box-msg">Ops... Acesso Bloqueado</h3>
                <p className="login-box-msg">Por algum motivo que não conseguimos verificar, seu acesso se encontra bloqueado.</p>
                <p className="login-box-msg">Por favor, entre em contato pelo número {config().FONE_OFICIAL} e informe o ocorrido.</p>
                <p className="login-box-msg">Pedimos desculpas pelo incomodo.</p>

                <Row>
                    <Grid cols="md-12">
                        <button type="button" className="btn btn-primary pull-right" onClick={this.props.logout}>Sair</button>
                    </Grid>
                </Row>


            </div>
        </div>
        )
    }
}

const mapStateToProps = state => ({ login_info: state.login })
const mapDispatchToProps = (dispatch) => bindActionCreators({ change_password, logout }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(LockPage)
